export type LocalUpgradeStatus = 'pending' | 'approved' | 'rejected';

export interface LocalReferrerUpgradeRequest {
  company_name: string;
  company_email: string;
  status: LocalUpgradeStatus;
  submitted_at: string;
}

const STORAGE_KEY = 'referrer_upgrade_request';

export function saveLocalReferrerUpgradeRequest(
  company_name: string, 
  company_email: string
): LocalReferrerUpgradeRequest {
  const payload: LocalReferrerUpgradeRequest = {
    company_name,
    company_email,
    status: 'pending',
    submitted_at: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

export function getLocalReferrerUpgradeRequest(): LocalReferrerUpgradeRequest | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as LocalReferrerUpgradeRequest) : null;
  } catch {
    return null;
  }
}

export function clearLocalReferrerUpgradeRequest(): void {
  localStorage.removeItem(STORAGE_KEY);
}
